import "./Button.scss";
import { useState } from "react";
import RegisterModal from "../TicketModal/TicketModal";
import { Link } from "react-router-dom";

export const RegisterBtn = () => {
  return (
    <Link to="/ticket">
      <button className="register-btn">Buy Ticket</button>
    </Link>
  );
};

export const RegisterBtnMobile = () => {
  return (
    <div className=" register-mobile">
      <Link to="/ticket">
        <button className="register-btn-mobile">Register Now</button>
      </Link>
    </div>
  );
};

export const Register = () => {
  const [showModal, setShowModal] = useState(false);

  const handleRegisterClick = () => {
    setShowModal(true);
  };
  return (
    <>
      <button className="register-btn" onClick={handleRegisterClick}>
        Register Now
      </button>

      {showModal && (
        <RegisterModal
          onClose={() => setShowModal(false)}
          showModal={showModal}
        />
      )}
    </>
  );
};
